/*
 * Termos de uso e política de privacidade.
 *
 * Item próprio no menu, e não dentro do painel de um MikroTik, por um motivo
 * que tem consequência: existe **uma** versão vigente de cada documento para o
 * sistema inteiro, e é a ela que o aceite gravado de cada cliente aponta.
 * Editá-los na tela de um equipamento diria que cada um tem os seus — o que é
 * falso, e alguém acreditaria.
 */
import { PERMISSIONS } from '@hotspot/shared';
import { useAuth } from '../lib/auth';
import { TermsManager } from '../components/TermsManager';
import { Card } from '../components/ui';

export function TermsPage() {
  const { can } = useAuth();

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-bold text-slate-900">Termos e privacidade</h1>
        <p className="text-sm text-slate-600">
          Os documentos que o cliente aceita antes de informar os dados dele. Valem para toda a
          rede: há uma versão vigente de cada um, e é a ela que o aceite de cada pessoa se
          refere.
        </p>
      </header>

      <Card>
        <div className="space-y-4">
          <p className="text-sm text-slate-600">
            Os textos que vieram na instalação são genéricos e válidos como estão — publique uma
            versão nova para incluir a razão social e os canais de atendimento da sua empresa.
          </p>

          <TermsManager podePublicar={can(PERMISSIONS.LGPD_MANAGE)} />
        </div>
      </Card>
    </div>
  );
}
